export const SYSTEM_USE_NOTIFICATION_DEFAULTS = {
  title: "System Use Notification",
  description:
    "This is a private system owned by 4Sight Labs and the affiliated agency. Access is restricted to authorized users only. By proceeding, you acknowledge and consent that:",
  acknowledgeAndConsent: [
    "Unauthorized use is strictly prohibited and may result in disciplinary action, civil penalties, and/or criminal prosecution.",
    "Users of this system are required to comply with all applicable laws, regulations, and policies, including but not limited to HIPAA security standards, for the protection of confidential and health-related data.",
    "All activity may be monitored, recorded, audited, and disclosed to law enforcement or other officials.",
    "There is no expectation of privacy when using this system.",
  ],
  acknowledgeButtonText: "Ok",
};

const text = (value) =>
  typeof value === "string" && value.trim() ? value : null;

export function getSystemUseNotificationContent(userData) {
  const authored = userData?.entityAssets?.systemUseNotification || {};

  const acknowledgeAndConsent = Array.isArray(authored.acknowledgeAndConsent)
    ? authored.acknowledgeAndConsent.filter((item) => text(item))
    : [];

  return {
    title: text(authored.title) || SYSTEM_USE_NOTIFICATION_DEFAULTS.title,
    description:
      text(authored.description) ||
      SYSTEM_USE_NOTIFICATION_DEFAULTS.description,
    acknowledgeAndConsent:
      acknowledgeAndConsent.length > 0
        ? acknowledgeAndConsent
        : SYSTEM_USE_NOTIFICATION_DEFAULTS.acknowledgeAndConsent,
    acknowledgeButtonText:
      text(authored.acknowledgeButtonText) ||
      SYSTEM_USE_NOTIFICATION_DEFAULTS.acknowledgeButtonText,
  };
}

export function isSystemUseNotificationEnabled(userData) {
  return Boolean(
    userData?.entityInformation?.entityPreference?.systemUseNotification,
  );
}

export function isSystemUseNotificationRequired(userData, userPermissions) {
  return (
    userData?.userInfo?.userRole !== "4SightAdmin" &&
    isSystemUseNotificationEnabled(userData) &&
    !userData?.userInfo?.disableSystemUseNotification &&
    userPermissions?.length > 0
  );
}
